export default {
  DEFAULT_COUNTRY_CODE_INDIA: '+91',
  DEFAULT_COUNTRY_CODE_NEW_ZEALAND: '+64',
} as const
